import { render, staticRenderFns } from "./DashboardProducerTicker.vue?vue&type=template&id=336085d9&"
import script from "./DashboardProducerTicker.vue?vue&type=script&lang=js&"
export * from "./DashboardProducerTicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports